import * as React from "react";
import {mapMarkerStyle, mapMarkerStyleBlack, mapMarkerStyleRed} from "../Map/MapMarker";
import {Map, MapMarker} from "../Map/Map";

export default function PreferentialOccupancy(props: {mapMarkers: MapMarker[]}) {

    let newMapMarkers: MapMarker[] = [];

    props.mapMarkers.map((mapMarker: any) => {
        const icons = mapMarker.icons;
        icons.map((icon: any, index: number) => {
            mapMarker.icons[index] = {'label': icon.label, 'style': mapMarkerStyle(icon.style), 'visible': true};
        });
        newMapMarkers.push(mapMarker);
    });
    
    return <Map
        minHeight={'200px'}
        height={'max(75vh, 550px)'}
        maxHeight={'800px'}
        minZoom={5.4}
        maxZoom={17}
        defaultZoom={5.6}
        center={{
            lng: 10.6, //kleiner nach rechts schieben
            lat: 50.7 //größer nach unten schieben
        }}
        mapMarkers={newMapMarkers}
        minLabelOccurrenceForLabelFilter={[]}
        legend={[
            {
                label: 'Seniorenwohn- und Pflegeeinrichtungen',
                style: mapMarkerStyleRed(),
            },
            {
                label: 'Betreutes Wohnen / Barrierefreies Wohnen',
                style: mapMarkerStyleBlack(),
            },
        ]}

    />
    
}